import React from 'react';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  inputSize?: 'lg' | 'md';
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ inputSize = 'md', className = '', ...rest }, ref) => {
    const cls = ['input', inputSize === 'lg' ? 'input-lg' : '', className]
      .filter(Boolean)
      .join(' ');
    return <input ref={ref} className={cls} {...rest} />;
  }
);
Input.displayName = 'Input';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className = '', ...rest }, ref) => (
  <textarea ref={ref} className={`textarea ${className}`} {...rest} />
));
Textarea.displayName = 'Textarea';

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className = '', ...rest }, ref) => (
  <select ref={ref} className={`select ${className}`} {...rest} />
));
Select.displayName = 'Select';

export const InputGroup: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  ...rest
}) => <div className={`input-group ${className}`} {...rest} />;

export const InputAddon: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({
  className = '',
  ...rest
}) => <span className={`input-addon ${className}`} {...rest} />;
